<script lang="ts" setup>
import { getCurrentInstance, computed } from 'vue';

defineOptions({
    name: 'field-time'
});

const props = defineProps({
  "modelValue": null,
  "label": null,
  "disabled": { type: Boolean, default: false }
});

const emit = defineEmits(["update:modelValue"]);

const instance = getCurrentInstance();
const uid = computed(() => `form-field-${instance.uid}`);

const update = (value: string | null): void =>
{
    emit('update:modelValue', value);
};

const handleInput = (event: Event) =>
{
    const target = event.target as HTMLInputElement;

    update(target.value || null);
};
</script>

<template>
    <div class="form-group">
        <label :for="uid" v-if="label">{{ label }}</label>
        <input
            :id="uid"
            type="time"
            class="form-control"
            :value="modelValue || ''"
            @input="handleInput"
            :disabled="disabled"
        />
    </div>
</template>
